import createIcon from '@/lib/create-icon'

const AmericanFootballIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M38.8695 13.021C38.6115 11.6227 37.9211 10.3161 36.8974 9.2886C35.8696 8.26528 34.5626 7.57512 33.164 7.31707C26.0496 6.13236 18.5751 8.28981 13.4394 13.4171C8.30485 18.5432 6.1359 26.012 7.31241 33.1261C7.57049 34.5244 8.26086 35.831 9.2845 36.8585C10.3123 37.8818 11.6193 38.5719 13.0181 38.8301C20.0884 40.1806 27.6798 37.8564 32.7519 32.7314C37.9355 27.635 40.1044 20.1369 38.8695 13.021Z'
      stroke='url(#paint0_linear_4792_533)'
      strokeWidth='3'
      fill='none'
    />
    <path
      d='M38.8695 13.021C38.6115 11.6227 37.9211 10.3161 36.8974 9.2886C35.8696 8.26528 34.5626 7.57512 33.164 7.31707C26.0496 6.13236 18.5751 8.28981 13.4394 13.4171C8.30485 18.5432 6.1359 26.012 7.31241 33.1261C7.57049 34.5244 8.26086 35.831 9.2845 36.8585C10.3123 37.8818 11.6193 38.5719 13.0181 38.8301C20.0884 40.1806 27.6798 37.8564 32.7519 32.7314C37.9355 27.635 40.1044 20.1369 38.8695 13.021Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='3'
      fill='none'
    />
    <path
      d='M38.8695 13.021C38.6115 11.6227 37.9211 10.3161 36.8974 9.2886C35.8696 8.26528 34.5626 7.57512 33.164 7.31707C26.0496 6.13236 18.5751 8.28981 13.4394 13.4171C8.30485 18.5432 6.1359 26.012 7.31241 33.1261C7.57049 34.5244 8.26086 35.831 9.2845 36.8585C10.3123 37.8818 11.6193 38.5719 13.0181 38.8301C20.0884 40.1806 27.6798 37.8564 32.7519 32.7314C37.9355 27.635 40.1044 20.1369 38.8695 13.021Z'
      stroke='url(#paint1_radial_4792_533)'
      strokeOpacity='0.6'
      strokeWidth='3'
      fill='none'
    />
    <path
      d='M9.54248 36.6654L36.665 9.54297'
      stroke='url(#paint2_linear_4792_533)'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M9.54248 36.6654L36.665 9.54297'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M9.54248 36.6654L36.665 9.54297'
      stroke='url(#paint3_radial_4792_533)'
      strokeOpacity='0.6'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M18.0181 23.104L23.1035 28.1895M23.1035 18.0186L28.189 23.104'
      stroke='url(#paint4_linear_4792_533)'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M18.0181 23.104L23.1035 28.1895M23.1035 18.0186L28.189 23.104'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <path
      d='M18.0181 23.104L23.1035 28.1895M23.1035 18.0186L28.189 23.104'
      stroke='url(#paint5_radial_4792_533)'
      strokeOpacity='0.6'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4792_533'
        x1='7'
        y1='7'
        x2='43.8186'
        y2='32.5684'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_4792_533'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.1039 39.208) scale(16.1039 16.4015)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_4792_533'
        x1='9.54248'
        y1='9.54297'
        x2='40.5477'
        y2='31.0743'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_4792_533'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.1037 36.6654) scale(13.5612 13.8118)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_4792_533'
        x1='18.0181'
        y1='18.0186'
        x2='29.645'
        y2='26.0928'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_4792_533'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(23.1035 28.1895) scale(5.08546 5.17941)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'AmericanFootballIcon'
)

export default AmericanFootballIcon
